import { HttpClient } from 'common/services/http-client.service';
import { Schema } from 'common/models/schema/schema.model';
import fileUploadConfig from 'common/redux/file-upload/fileUpload.config';
import dataEditorApiConfig from './dataEditor.config';

export class DataEditorService extends HttpClient {
    public static loadToMasterData(payload: Schema) {
        return this.invokeApi(fileUploadConfig.addSyncLog(payload));
    }

    public static clearPreview() {
        return this.invokeApi(dataEditorApiConfig.clearPreview());
    }
}
